<template>
  <div>
    <div>
      <label for="default_aqopi_sources">
        De volgende bronnen worden aangesproken bij deze soort inventarisatie
      </label>
      <a-select
          title="Standaard bronnen bij deze inventarisatie"
          mode="multiple"
          name="default_aqopi_sources"
          :value="defaultSourcesOptionsValues"
          :options="defaultSourcesOptions"
          disabled>
      </a-select>
    </div>
    <!--    <div>-->
    <!--      <label for="additional_aqopi_sources">Bronnen toevoegen</label>-->
    <!--      <a-select-->
    <!--        mode="multiple"-->
    <!--        :options="availableAqopiSources"-->
    <!--        v-model="selectedAvailableSources"-->
    <!--      >-->
    <!--      </a-select>-->
    <!--    </div>-->
    <input v-for="value in selectedAvailableSources" type="hidden" name="additional_aqopi_sources[]" :value="value"
           :key="value">
  </div>
</template>

<script>
import AqopiSourceApi from '~/api/aqopiSource';

export default {
  name: "InvitationSources",
  data() {
    return {
      defaultSources: [],
      availableSources: [],
      selectedAvailableSources: [],
      selectedInvitationTypeValue: "full",
    }
  },
  computed: {
    defaultSourcesOptions() {
      return this.defaultSources.map((source) => ({label: source.display_name, value: source.id}));
    },
    defaultSourcesOptionsValues() {
      return this.defaultSources.map((source) => source.id);
    },
    availableAqopiSources() {
      return this.availableSources.map((source) => ({label: source.display_name, value: source.id}));
    },
  },
  mounted() {
    $("input[type=radio][name=type]").on("input", () => {
      this.selectedInvitationTypeValue = $("input[type=radio][name=type]").filter(':checked').val();
      this.loadDefaultSources();
      this.loadAvailableSources();
    });
    this.loadDefaultSources();
    this.loadAvailableSources();
  },
  methods: {
    // TODO: move to new api file
    loadDefaultSources() {
      AqopiSourceApi.getDefaultSourcesByInvitationType(this.selectedInvitationTypeValue)
          .then((response) => {
            let defaultSourcesElement = $("#aqopi-sources-list")
            defaultSourcesElement.empty()
            this.defaultSources = response.data
          });
    },
    loadAvailableSources() {
      AqopiSourceApi.getAvailableSourcesByInvitationType(this.selectedInvitationTypeValue)
          .then((response) => {
            let availableSourcesElement = $("#add-additional-aqopi-sources")
            availableSourcesElement.empty()
            this.selectedAvailableSources = [];
            this.availableSources = response.data;
          });
    }
  }
};
</script>

<style scoped>

</style>
